/**
 * @file 脚本工具
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import originRequest from '../../../utils/request';
import API from './api';

// 添加到脚本库
export const addScript = params => {
    return request(
        API.GET_SCRIPT_ADD, {
            method: 'POSTJSON',
            body: params
        }
    );
};
// 获取脚本详情信息
export const getScriptLibInfo = params => {
    return request(
        API.GET_SCRIPT_INFO, {
            method: 'POSTJSON',
            body: params
        }
    );
};


// 删除某一个剧本
export const delScriptLibItem = params => {
    return request(
        API.GET_SCRIPT_DEL, {
            method: 'POSTJSON',
            body: params
        }
    );
};


// 获取脚本列表
export const getScriptLibList = params => {
    return request(
        API.GET_SCRIPT_LIB_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 *  风格列表
 * @param {*} params
 * @returns
 */
export const getFollowStyleList = async params => {
    return request(
        API.GET_FPLLOW_STYLE_LIST, {
            method: 'POSTJSON',
            body: params

        }
    );
};

// 生成剧本
export const getGenerateStart = params => {
    return request(
        API.GET_GENERATE_START, {
            method: 'POSTJSON',
            body: params
        }
    );
};
// 获取生成结果
export const getGenerateRes = params => {
    return request(
        API.GET_GENERATE_RES, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 获取ASR任务进度
 * @returns Promise
 */
export const getScriptToolAsrProcess = async params => {
    return request(
        API.GET_ASR_DETAIL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

// 根据商品id获取商品详情信息
export const getGoodsMsg = params => {
    return request(
        API.GET_GOODS_MSG, {
            method: 'POSTJSON',
            body: params
        }
    );
};